import React, { useState } from 'react';
import { Check, Star, TrendingUp, Rocket, Target, Zap } from 'lucide-react';

const PricingPlansSection = () => {
  const [isMonthly, setIsMonthly] = useState(true);

  const plans = [
    {
      id: 'pro-growth',
      name: 'Pro Growth',
      icon: <Star className="w-6 h-6" />,
      monthlyPrice: 2499,
      prepaidPrice: 13495,
      features: [
        'GBP Optimization - 50+ Keywords',
        'GBP Weekly Updates (Includes Post, Photo, And Video)',
        'Directory Listings',
        'AI Reputation Management',
        '10-Page WordPress Website Or On-Page SEO Up To 10 Pages',
        '2 New Site Pages/Month For SEO Ranking',
        'Up To 20 Location Specific Pages For Site',
        'Schema Markup',
        'CRM With Testing For Lead Management',
        '4 Blogs Per Month (Long Form)',
        '4 Social Media Posts Per Month (High Quality Image)',
        '1 Local Press Release Per Month',
        'Brand Advisor',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: false
    },
    {
      id: 'growth',
      name: 'Growth',
      icon: <TrendingUp className="w-6 h-6" />,
      monthlyPrice: 1499,
      prepaidPrice: 8994,
      features: [
        'GBP Optimization - 30+ Keywords',
        'GBP Weekly Updates (Includes Post, Photo, And Video)',
        'Directory Listings',
        'AI Reputation Management',
        '10-Page WordPress Website Or On-Page SEO Up To 10 Pages',
        'CRM With Testing For Lead Management',
        'Up To 10 Location Specific Pages For Site',
        'Schema Markup',
        '4 Blogs Per Month (Long Form)',
        '4 Social Media Posts Per Month (High Quality Image)',
        '1 Local Press Release Per Month',
        'Brand Advisor',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: false
    },
    {
      id: 'elevate',
      name: 'Elevate',
      icon: <Rocket className="w-6 h-6" />,
      monthlyPrice: 999,
      prepaidPrice: 5395,
      features: [
        'GBP Optimization - 20+ Keywords',
        'GBP Weekly Updates (Includes Post, Photo, And Video)',
        'Directory Listings',
        'AI Reputation Management',
        '7-Page WordPress Website Or On-Page SEO Up To 7 Pages',
        'CRM With Testing For Lead Management',
        'Up To 10 Location Specific Pages For Site',
        'Schema Markup',
        '3 Blogs Per Month (Long Form)',
        '3 Social Media Posts Per Month (High Quality Image)',
        'Brand Advisor',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: true
    },
    {
      id: 'advantage',
      name: 'Advantage',
      icon: <Target className="w-6 h-6" />,
      monthlyPrice: 749,
      prepaidPrice: 4494,
      features: [
        'GBP Optimization - 20 Keywords',
        'Keyword Research',
        'Directory Listings',
        'Review Generation',
        '5-Page WordPress Website',
        '2 Website Blog Posts',
        '2 Social Media Posts',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: false
    },
    {
      id: 'awareness',
      name: 'Awareness',
      icon: <Zap className="w-6 h-6" />,
      monthlyPrice: 549,
      prepaidPrice: 3294,
      features: [
        'GBP Optimization - 15 Keywords',
        'Keyword Research',
        'Directory Listings',
        'Review Generation',
        '3-Page WordPress Website',
        '1 Post - Social Media Or Website Blog',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: false
    },
    {
      id: 'essentials',
      name: 'Essentials',
      icon: <Check className="w-6 h-6" />,
      monthlyPrice: 349,
      prepaidPrice: 2094,
      features: [
        'GBP Optimization - 10 Keywords',
        'Keyword Research',
        'Directory Listings',
        'Real-Time Dashboard Reporting'
      ],
      isPopular: false
    }
  ];

  return (
    <div className="bg-white py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Our Marketing Business Plan Options
          </h2>
          
          {/* Toggle de precios */}
          <div className="flex items-center justify-center space-x-4 mb-8">
            <span className={`text-lg font-medium ${isMonthly ? 'text-gray-800' : 'text-gray-500'}`}>
              MONTHLY
            </span>
            <button
              onClick={() => setIsMonthly(!isMonthly)}
              className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors ${
                isMonthly ? 'bg-gray-300' : 'bg-red-600'
              }`}
            >
              <span
                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${
                  isMonthly ? 'translate-x-1' : 'translate-x-9'
                }`}
              />
            </button>
            <span className={`text-lg font-medium ${!isMonthly ? 'text-gray-800' : 'text-gray-500'}`}>
              PREPAID
            </span>
          </div>

          {/* Botón GET STARTED */}
          <button className="bg-red-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors">
            GET STARTED
          </button>
        </div>

        {/* Grid de planes */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`relative bg-white border border-gray-200 rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow ${
                plan.isPopular ? 'ring-2 ring-red-500' : ''
              }`}
            >
              {/* Badge Most Popular */}
              {plan.isPopular && (
                <div className="absolute -top-3 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </div>
              )}

              {/* Header del plan */}
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <div className="text-red-600">
                    {plan.icon}
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">{plan.name}</h3>
                </div>
              </div>

              {/* Línea divisoria */}
              <div className="border-t border-dashed border-gray-300 mb-6"></div>

              {/* Precio */}
              <div className="mb-6">
                <div className="flex items-baseline">
                  <span className="text-4xl font-bold text-red-600">
                    ${isMonthly ? plan.monthlyPrice.toLocaleString() : plan.prepaidPrice.toLocaleString()}
                  </span>
                  <span className="text-gray-500 ml-2">
                    {isMonthly ? 'Monthly' : 'Prepaid'}
                  </span>
                </div>
              </div>

              {/* Lista de características */}
              <div className="space-y-3 mb-8">
                {plan.features.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <Check className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-600 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              {/* Botón de selección */}
              <button className="w-full bg-red-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-red-700 transition-colors">
                Choose Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPlansSection;


